<template>
  <div v-if="props.loading"
       class="card">
    <div class="card-figure d-flex align-items-center justify-content-center">
      <Skeletor width="115"
                height="45" />
    </div>

    <div class="card-body">
      <div class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>GBIN</strong></div>
        <div class="col-12 col-sm-7">
          <Skeletor width="100%" />
        </div>
      </div>

      <div class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>Name</strong></div>
        <div class="col-12 col-sm-7">
          <Skeletor width="100%" />
        </div>
      </div>

      <div class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>Synonyms</strong></div>
        <div class="col-12 col-sm-7">
          <Skeletor width="100%" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-5"><strong>Website</strong></div>
        <div class="col-12 col-sm-7">
          <Skeletor width="100%" />
        </div>
      </div>
    </div>
  </div>

  <div v-if="props.details && !props.loading"
       class="card">
    <div class="card-figure d-flex align-items-center justify-content-center">
      <a v-if="props.details.websiteUrl"
         :title="props.details.name"
         :href="`//${props.details.websiteUrl}`"
         target="_blank">
        <img v-if="props.details.logoUrl"
             :src="props.details.logoUrl"
             :alt="props.details.name"
             class="card-img card-img-top img-fluid" />

        <img v-else
             src="@/assets/images/placeholder-brand.png"
             :alt="props.details.name" />
      </a>

      <template v-else>
        <img v-if="props.details.logoUrl"
             :src="props.details.logoUrl"
             :alt="props.details.name"
             class="card-img card-img-top img-fluid" />

        <img v-else
             src="@/assets/images/placeholder-brand.png"
             :alt="props.details.name" />
      </template>
    </div>

    <div class="card-body">
      <div class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>GBIN</strong></div>
        <div class="col-12 col-sm-7">
          {{ props.details.gbin }}
          <input id="GBINCopy"
                 type="hidden"
                 :value="props.details.gbin" />

          <a @click="copyToClickBoard"
             href="#"
             ref="tooltipRef">
            <i class="far fa-copy ms-1"></i>
          </a>
        </div>
      </div>

      <div class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>Name</strong></div>
        <div class="col-12 col-sm-7">{{ props.details.name }}</div>
      </div>

      <div v-if="props.details.alternativeNames && props.details.alternativeNames.length > 0"
           class="row mb-1 mb-sm-0">
        <div class="col-12 col-sm-5"><strong>Synonyms</strong></div>
        <div class="col-12 col-sm-7">
          <ul class="list-unstyled mb-0">
            <li v-for="(name, nameIndex) in props.details.alternativeNames"
                :key="nameIndex">
              {{ name }}
            </li>
          </ul>
        </div>
      </div>

      <div v-if="props.details.websiteUrl"
           class="row">
        <div class="col-12 col-sm-5"><strong>Website</strong></div>
        <div class="col-12 col-sm-7">
          <a :title="props.details.name"
             :href="`//${props.details.websiteUrl}`"
             target="_blank">
            {{ props.details.websiteUrl }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, nextTick, onBeforeUnmount, ref, watch } from "vue";
import { Tooltip } from "bootstrap";

/**
 *  GETTING & LOADING (API) DATA
 */
const props = defineProps({
  name: String,
  logoUrl: String,
  loading: Boolean,
  details: Object,
});

/**
 * Tooltip
 */
const tooltipRef = ref(null);

watch(
  () => props.loading,
  (value) => value === false && nextTick(() => createTooltip())
);

function createTooltip() {
  new Tooltip(tooltipRef.value, {
    title: "Copy to clipboard",
    placement: "top",
    trigger: "hover",
    html: true,
  });
}

/* Copy to clipboard script */
function copyToClickBoard() {
  // set new 'copied title'
  tooltipRef.value.setAttribute(
    "data-bs-original-title",
    '<i class="far fa-check text-primary me-1"></i>GBIN has been copied'
  );
  Tooltip.getInstance(tooltipRef.value).show();

  // set to clipboard
  const content = document.getElementById("GBINCopy").value;
  navigator.clipboard.writeText(content);

  // revert back to original title
  setTimeout(() => {
    tooltipRef.value.setAttribute(
      "data-bs-original-title",
      "Copy to clipboard"
    );
    Tooltip.getInstance(tooltipRef.value).show();
  }, 2000);
}

// Destroy the copy to clipboard tooltip before unmount
onBeforeUnmount(() => {
  Tooltip.getInstance(tooltipRef.value).dispose();
});
</script>
